export default {
    "name": "CheckoutCreate",
    "kind": "HoudiniMutation",
    "hash": "0ec71bb452e150cd0111ede9287e790529d5ccec591b81ac4eaf3a6880e0b12e",

    "raw": `mutation CheckoutCreate($input: CheckoutCreateInput!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  checkoutCreate(input: $input) {
    checkout {
      id
      webUrl
      email
      subtotalPrice {
        amount
        currencyCode
      }
      totalPrice {
        amount
        currencyCode
      }
      shippingAddress {
        firstName
        company
        lastName
        phone
        address1
        address2
        city
        zip
        id
      }
      lineItemsSubtotalPrice {
        amount
        currencyCode
      }
      lineItems(first: 10) {
        edges {
          node {
            quantity
            title
            variant {
              id
              sku
              image_urls: metafield(key: "image_urls", namespace: "sprenger") {
                key
                value
                id
              }
              selectedOptions {
                name
                value
              }
              product {
                handle
                sku: metafield(key: "sku", namespace: "sprenger") {
                  key
                  value
                  id
                }
                justSku: metafield(key: "just_sku", namespace: "sprenger") {
                  key
                  value
                  id
                }
                collections(first: 100) {
                  edges {
                    node {
                      title
                      description
                      id
                    }
                  }
                }
                id
              }
              bundle_desc: metafield(key: "bundle_desc", namespace: "sprenger") {
                key
                value
                id
              }
              justSku: metafield(key: "just_sku", namespace: "sprenger") {
                key
                value
                id
              }
              unitPrice {
                amount
                currencyCode
              }
              unitPriceMeasurement {
                referenceUnit
                referenceValue
              }
              price {
                amount
                currencyCode
              }
            }
            id
          }
        }
      }
      discountApplications(first: 99) {
        edges {
          node {
            allocationMethod
            targetSelection
            targetType
            value {
              ... on MoneyV2 {
                __typename
                amount
                currencyCode
              }
              ... on PricingPercentageValue {
                __typename
                percentage
              }
              __typename
            }
            ... on DiscountCodeApplication {
              code
            }
            __typename
          }
        }
      }
      appliedGiftCards {
        amountUsedV2 {
          amount
          currencyCode
        }
        balanceV2 {
          amount
          currencyCode
        }
        presentmentAmountUsed {
          amount
          currencyCode
        }
        id
      }
    }
    checkoutUserErrors {
      code
      field
      message
    }
  }
}
`,

    "rootType": "Mutation",

    "selection": {
        "fields": {
            "checkoutCreate": {
                "type": "CheckoutCreatePayload",
                "keyRaw": "checkoutCreate(input: $input)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "checkout": {
                            "type": "Checkout",
                            "keyRaw": "checkout",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "webUrl": {
                                        "type": "URL",
                                        "keyRaw": "webUrl",
                                        "visible": true
                                    },

                                    "email": {
                                        "type": "String",
                                        "keyRaw": "email",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "subtotalPrice": {
                                        "type": "MoneyV2",
                                        "keyRaw": "subtotalPrice",

                                        "selection": {
                                            "fields": {
                                                "amount": {
                                                    "type": "Decimal",
                                                    "keyRaw": "amount",
                                                    "visible": true
                                                },

                                                "currencyCode": {
                                                    "type": "CurrencyCode",
                                                    "keyRaw": "currencyCode",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "totalPrice": {
                                        "type": "MoneyV2",
                                        "keyRaw": "totalPrice",

                                        "selection": {
                                            "fields": {
                                                "amount": {
                                                    "type": "Decimal",
                                                    "keyRaw": "amount",
                                                    "visible": true
                                                },

                                                "currencyCode": {
                                                    "type": "CurrencyCode",
                                                    "keyRaw": "currencyCode",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "shippingAddress": {
                                        "type": "MailingAddress",
                                        "keyRaw": "shippingAddress",
                                        "nullable": true,

                                        "selection": {
                                            "fields": {
                                                "firstName": {
                                                    "type": "String",
                                                    "keyRaw": "firstName",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "company": {
                                                    "type": "String",
                                                    "keyRaw": "company",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "lastName": {
                                                    "type": "String",
                                                    "keyRaw": "lastName",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "phone": {
                                                    "type": "String",
                                                    "keyRaw": "phone",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "address1": {
                                                    "type": "String",
                                                    "keyRaw": "address1",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "address2": {
                                                    "type": "String",
                                                    "keyRaw": "address2",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "city": {
                                                    "type": "String",
                                                    "keyRaw": "city",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "zip": {
                                                    "type": "String",
                                                    "keyRaw": "zip",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "ID",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "lineItemsSubtotalPrice": {
                                        "type": "MoneyV2",
                                        "keyRaw": "lineItemsSubtotalPrice",

                                        "selection": {
                                            "fields": {
                                                "amount": {
                                                    "type": "Decimal",
                                                    "keyRaw": "amount",
                                                    "visible": true
                                                },

                                                "currencyCode": {
                                                    "type": "CurrencyCode",
                                                    "keyRaw": "currencyCode",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "lineItems": {
                                        "type": "CheckoutLineItemConnection",
                                        "keyRaw": "lineItems(first: 10)",

                                        "selection": {
                                            "fields": {
                                                "edges": {
                                                    "type": "CheckoutLineItemEdge",
                                                    "keyRaw": "edges",

                                                    "selection": {
                                                        "fields": {
                                                            "node": {
                                                                "type": "CheckoutLineItem",
                                                                "keyRaw": "node",

                                                                "selection": {
                                                                    "fields": {
                                                                        "quantity": {
                                                                            "type": "Int",
                                                                            "keyRaw": "quantity",
                                                                            "visible": true
                                                                        },

                                                                        "title": {
                                                                            "type": "String",
                                                                            "keyRaw": "title",
                                                                            "visible": true
                                                                        },

                                                                        "variant": {
                                                                            "type": "ProductVariant",
                                                                            "keyRaw": "variant",
                                                                            "nullable": true,

                                                                            "selection": {
                                                                                "fields": {
                                                                                    "id": {
                                                                                        "type": "ID",
                                                                                        "keyRaw": "id",
                                                                                        "visible": true
                                                                                    },

                                                                                    "sku": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "sku",
                                                                                        "nullable": true,
                                                                                        "visible": true
                                                                                    },

                                                                                    "image_urls": {
                                                                                        "type": "Metafield",
                                                                                        "keyRaw": "image_urls(key: \"image_urls\", namespace: \"sprenger\")",
                                                                                        "nullable": true,

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "key": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "key",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "value": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "value",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "id": {
                                                                                                    "type": "ID",
                                                                                                    "keyRaw": "id",
                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    },

                                                                                    "selectedOptions": {
                                                                                        "type": "SelectedOption",
                                                                                        "keyRaw": "selectedOptions",

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "name": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "name",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "value": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "value",
                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    },

                                                                                    "product": {
                                                                                        "type": "Product",
                                                                                        "keyRaw": "product",

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "handle": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "handle",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "sku": {
                                                                                                    "type": "Metafield",
                                                                                                    "keyRaw": "sku(key: \"sku\", namespace: \"sprenger\")",
                                                                                                    "nullable": true,

                                                                                                    "selection": {
                                                                                                        "fields": {
                                                                                                            "key": {
                                                                                                                "type": "String",
                                                                                                                "keyRaw": "key",
                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "value": {
                                                                                                                "type": "String",
                                                                                                                "keyRaw": "value",
                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "id": {
                                                                                                                "type": "ID",
                                                                                                                "keyRaw": "id",
                                                                                                                "visible": true
                                                                                                            }
                                                                                                        }
                                                                                                    },

                                                                                                    "visible": true
                                                                                                },

                                                                                                "justSku": {
                                                                                                    "type": "Metafield",
                                                                                                    "keyRaw": "justSku(key: \"just_sku\", namespace: \"sprenger\")",
                                                                                                    "nullable": true,

                                                                                                    "selection": {
                                                                                                        "fields": {
                                                                                                            "key": {
                                                                                                                "type": "String",
                                                                                                                "keyRaw": "key",
                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "value": {
                                                                                                                "type": "String",
                                                                                                                "keyRaw": "value",
                                                                                                                "visible": true
                                                                                                            },

                                                                                                            "id": {
                                                                                                                "type": "ID",
                                                                                                                "keyRaw": "id",
                                                                                                                "visible": true
                                                                                                            }
                                                                                                        }
                                                                                                    },

                                                                                                    "visible": true
                                                                                                },

                                                                                                "collections": {
                                                                                                    "type": "CollectionConnection",
                                                                                                    "keyRaw": "collections(first: 100)",

                                                                                                    "selection": {
                                                                                                        "fields": {
                                                                                                            "edges": {
                                                                                                                "type": "CollectionEdge",
                                                                                                                "keyRaw": "edges",

                                                                                                                "selection": {
                                                                                                                    "fields": {
                                                                                                                        "node": {
                                                                                                                            "type": "Collection",
                                                                                                                            "keyRaw": "node",

                                                                                                                            "selection": {
                                                                                                                                "fields": {
                                                                                                                                    "title": {
                                                                                                                                        "type": "String",
                                                                                                                                        "keyRaw": "title",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "description": {
                                                                                                                                        "type": "String",
                                                                                                                                        "keyRaw": "description",
                                                                                                                                        "visible": true
                                                                                                                                    },

                                                                                                                                    "id": {
                                                                                                                                        "type": "ID",
                                                                                                                                        "keyRaw": "id",
                                                                                                                                        "visible": true
                                                                                                                                    }
                                                                                                                                }
                                                                                                                            },

                                                                                                                            "visible": true
                                                                                                                        }
                                                                                                                    }
                                                                                                                },

                                                                                                                "visible": true
                                                                                                            }
                                                                                                        }
                                                                                                    },

                                                                                                    "visible": true
                                                                                                },

                                                                                                "id": {
                                                                                                    "type": "ID",
                                                                                                    "keyRaw": "id",
                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    },

                                                                                    "bundle_desc": {
                                                                                        "type": "Metafield",
                                                                                        "keyRaw": "bundle_desc(key: \"bundle_desc\", namespace: \"sprenger\")",
                                                                                        "nullable": true,

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "key": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "key",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "value": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "value",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "id": {
                                                                                                    "type": "ID",
                                                                                                    "keyRaw": "id",
                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    },

                                                                                    "justSku": {
                                                                                        "type": "Metafield",
                                                                                        "keyRaw": "justSku(key: \"just_sku\", namespace: \"sprenger\")",
                                                                                        "nullable": true,

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "key": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "key",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "value": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "value",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "id": {
                                                                                                    "type": "ID",
                                                                                                    "keyRaw": "id",
                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    },

                                                                                    "unitPrice": {
                                                                                        "type": "MoneyV2",
                                                                                        "keyRaw": "unitPrice",
                                                                                        "nullable": true,

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "amount": {
                                                                                                    "type": "Decimal",
                                                                                                    "keyRaw": "amount",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "currencyCode": {
                                                                                                    "type": "CurrencyCode",
                                                                                                    "keyRaw": "currencyCode",
                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    },

                                                                                    "unitPriceMeasurement": {
                                                                                        "type": "UnitPriceMeasurement",
                                                                                        "keyRaw": "unitPriceMeasurement",
                                                                                        "nullable": true,

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "referenceUnit": {
                                                                                                    "type": "UnitPriceMeasurementMeasuredUnit",
                                                                                                    "keyRaw": "referenceUnit",
                                                                                                    "nullable": true,
                                                                                                    "visible": true
                                                                                                },

                                                                                                "referenceValue": {
                                                                                                    "type": "Int",
                                                                                                    "keyRaw": "referenceValue",
                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    },

                                                                                    "price": {
                                                                                        "type": "MoneyV2",
                                                                                        "keyRaw": "price",

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "amount": {
                                                                                                    "type": "Decimal",
                                                                                                    "keyRaw": "amount",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "currencyCode": {
                                                                                                    "type": "CurrencyCode",
                                                                                                    "keyRaw": "currencyCode",
                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    }
                                                                                }
                                                                            },

                                                                            "visible": true
                                                                        },

                                                                        "id": {
                                                                            "type": "ID",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "discountApplications": {
                                        "type": "DiscountApplicationConnection",
                                        "keyRaw": "discountApplications(first: 99)",

                                        "selection": {
                                            "fields": {
                                                "edges": {
                                                    "type": "DiscountApplicationEdge",
                                                    "keyRaw": "edges",

                                                    "selection": {
                                                        "fields": {
                                                            "node": {
                                                                "type": "DiscountApplication",
                                                                "keyRaw": "node",

                                                                "selection": {
                                                                    "abstractFields": {
                                                                        "fields": {
                                                                            "DiscountCodeApplication": {
                                                                                "code": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "code",
                                                                                    "visible": true
                                                                                },

                                                                                "allocationMethod": {
                                                                                    "type": "DiscountApplicationAllocationMethod",
                                                                                    "keyRaw": "allocationMethod",
                                                                                    "visible": true
                                                                                },

                                                                                "targetSelection": {
                                                                                    "type": "DiscountApplicationTargetSelection",
                                                                                    "keyRaw": "targetSelection",
                                                                                    "visible": true
                                                                                },

                                                                                "targetType": {
                                                                                    "type": "DiscountApplicationTargetType",
                                                                                    "keyRaw": "targetType",
                                                                                    "visible": true
                                                                                },

                                                                                "value": {
                                                                                    "type": "PricingValue",
                                                                                    "keyRaw": "value",

                                                                                    "selection": {
                                                                                        "abstractFields": {
                                                                                            "fields": {
                                                                                                "MoneyV2": {
                                                                                                    "__typename": {
                                                                                                        "type": "String",
                                                                                                        "keyRaw": "__typename",
                                                                                                        "visible": true
                                                                                                    },

                                                                                                    "amount": {
                                                                                                        "type": "Decimal",
                                                                                                        "keyRaw": "amount",
                                                                                                        "visible": true
                                                                                                    },

                                                                                                    "currencyCode": {
                                                                                                        "type": "CurrencyCode",
                                                                                                        "keyRaw": "currencyCode",
                                                                                                        "visible": true
                                                                                                    }
                                                                                                },

                                                                                                "PricingPercentageValue": {
                                                                                                    "__typename": {
                                                                                                        "type": "String",
                                                                                                        "keyRaw": "__typename",
                                                                                                        "visible": true
                                                                                                    },

                                                                                                    "percentage": {
                                                                                                        "type": "Float",
                                                                                                        "keyRaw": "percentage",
                                                                                                        "visible": true
                                                                                                    }
                                                                                                }
                                                                                            },

                                                                                            "typeMap": {}
                                                                                        },

                                                                                        "fields": {
                                                                                            "__typename": {
                                                                                                "type": "String",
                                                                                                "keyRaw": "__typename",
                                                                                                "visible": true
                                                                                            }
                                                                                        }
                                                                                    },

                                                                                    "abstract": true,
                                                                                    "visible": true
                                                                                },

                                                                                "__typename": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "__typename",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "typeMap": {}
                                                                    },

                                                                    "fields": {
                                                                        "allocationMethod": {
                                                                            "type": "DiscountApplicationAllocationMethod",
                                                                            "keyRaw": "allocationMethod",
                                                                            "visible": true
                                                                        },

                                                                        "targetSelection": {
                                                                            "type": "DiscountApplicationTargetSelection",
                                                                            "keyRaw": "targetSelection",
                                                                            "visible": true
                                                                        },

                                                                        "targetType": {
                                                                            "type": "DiscountApplicationTargetType",
                                                                            "keyRaw": "targetType",
                                                                            "visible": true
                                                                        },

                                                                        "value": {
                                                                            "type": "PricingValue",
                                                                            "keyRaw": "value",

                                                                            "selection": {
                                                                                "abstractFields": {
                                                                                    "fields": {
                                                                                        "MoneyV2": {
                                                                                            "__typename": {
                                                                                                "type": "String",
                                                                                                "keyRaw": "__typename",
                                                                                                "visible": true
                                                                                            },

                                                                                            "amount": {
                                                                                                "type": "Decimal",
                                                                                                "keyRaw": "amount",
                                                                                                "visible": true
                                                                                            },

                                                                                            "currencyCode": {
                                                                                                "type": "CurrencyCode",
                                                                                                "keyRaw": "currencyCode",
                                                                                                "visible": true
                                                                                            }
                                                                                        },

                                                                                        "PricingPercentageValue": {
                                                                                            "__typename": {
                                                                                                "type": "String",
                                                                                                "keyRaw": "__typename",
                                                                                                "visible": true
                                                                                            },

                                                                                            "percentage": {
                                                                                                "type": "Float",
                                                                                                "keyRaw": "percentage",
                                                                                                "visible": true
                                                                                            }
                                                                                        }
                                                                                    },

                                                                                    "typeMap": {}
                                                                                },

                                                                                "fields": {
                                                                                    "__typename": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "__typename",
                                                                                        "visible": true
                                                                                    }
                                                                                }
                                                                            },

                                                                            "abstract": true,
                                                                            "visible": true
                                                                        },

                                                                        "__typename": {
                                                                            "type": "String",
                                                                            "keyRaw": "__typename",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "abstract": true,
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "appliedGiftCards": {
                                        "type": "AppliedGiftCard",
                                        "keyRaw": "appliedGiftCards",

                                        "selection": {
                                            "fields": {
                                                "amountUsedV2": {
                                                    "type": "MoneyV2",
                                                    "keyRaw": "amountUsedV2",

                                                    "selection": {
                                                        "fields": {
                                                            "amount": {
                                                                "type": "Decimal",
                                                                "keyRaw": "amount",
                                                                "visible": true
                                                            },

                                                            "currencyCode": {
                                                                "type": "CurrencyCode",
                                                                "keyRaw": "currencyCode",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "balanceV2": {
                                                    "type": "MoneyV2",
                                                    "keyRaw": "balanceV2",

                                                    "selection": {
                                                        "fields": {
                                                            "amount": {
                                                                "type": "Decimal",
                                                                "keyRaw": "amount",
                                                                "visible": true
                                                            },

                                                            "currencyCode": {
                                                                "type": "CurrencyCode",
                                                                "keyRaw": "currencyCode",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "presentmentAmountUsed": {
                                                    "type": "MoneyV2",
                                                    "keyRaw": "presentmentAmountUsed",

                                                    "selection": {
                                                        "fields": {
                                                            "amount": {
                                                                "type": "Decimal",
                                                                "keyRaw": "amount",
                                                                "visible": true
                                                            },

                                                            "currencyCode": {
                                                                "type": "CurrencyCode",
                                                                "keyRaw": "currencyCode",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "ID",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "checkoutUserErrors": {
                            "type": "CheckoutUserError",
                            "keyRaw": "checkoutUserErrors",

                            "selection": {
                                "fields": {
                                    "code": {
                                        "type": "CheckoutErrorCode",
                                        "keyRaw": "code",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "field": {
                                        "type": "String",
                                        "keyRaw": "field",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "message": {
                                        "type": "String",
                                        "keyRaw": "message",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "input": "CheckoutCreateInput",
            "country": "CountryCode",
            "language": "LanguageCode"
        },

        "types": {
            "CheckoutBuyerIdentityInput": {
                "countryCode": "CountryCode"
            },

            "AttributeInput": {
                "key": "String",
                "value": "String"
            },

            "CheckoutLineItemInput": {
                "customAttributes": "AttributeInput",
                "quantity": "Int",
                "variantId": "ID"
            },

            "MailingAddressInput": {
                "address1": "String",
                "address2": "String",
                "city": "String",
                "company": "String",
                "country": "String",
                "firstName": "String",
                "lastName": "String",
                "phone": "String",
                "province": "String",
                "zip": "String"
            },

            "CheckoutCreateInput": {
                "allowPartialAddresses": "Boolean",
                "buyerIdentity": "CheckoutBuyerIdentityInput",
                "customAttributes": "AttributeInput",
                "email": "String",
                "lineItems": "CheckoutLineItemInput",
                "note": "String",
                "shippingAddress": "MailingAddressInput"
            }
        }
    }
};

"HoudiniHash=452f4e0afa7198398b77cbc4bcb7cbf1c0fa4973d3f211b45ded235f65835de8";